// src/config/routes.js

/* ================= DASHBOARD GROUPS ================= */
export const ROLE_DASHBOARD_GROUPS = {
  manager: ['manager', 'rm', 'zm'],
  employee: ['employee', 'cashier', 'accountant', 'sales_marketing'],
  grivirence: ['grivirence', 'go_auditor']
};

/* ================= DASHBOARD PATHS ================= */
export const DASHBOARD_PATHS = {
  admin: '/twgl&articles/admin/dashboard',
  manager: '/twgl&articles/manager/dashboard',
  employee: '/twgl&articles/employee/dashboard',
  grivirence: '/twgl&articles/grivirence/dashboard',

  auditor: '/twgl&articles/auditor/dashboard',
  hr: '/twgl&articles/hr/dashboard',
  administration: '/twgl&articles/administration/dashboard',

  default: '/twgl&articles/home'
};

/* ================= DASHBOARD RESOLVER ================= */
export const resolveDashboardPath = (role) => {
  if (!role) return DASHBOARD_PATHS.default;

  if (ROLE_DASHBOARD_GROUPS.manager.includes(role)) {
    return DASHBOARD_PATHS.manager;
  }

  if (ROLE_DASHBOARD_GROUPS.employee.includes(role)) {
    return DASHBOARD_PATHS.employee;
  }

  if (ROLE_DASHBOARD_GROUPS.grivirence.includes(role)) {
    return DASHBOARD_PATHS.grivirence;
  }

  return DASHBOARD_PATHS[role] || DASHBOARD_PATHS.default;
};

/* ================= PUBLIC PATHS ================= */
export const PUBLIC_PATHS = [
  '/',
  '/twgl&articles/home',
  '/twgl&articles/login'
];